import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../core/auth/services/auth.service';
import { inject } from '@angular/core';
import { UserRole } from '../../core/auth/models/profile';

export function UserGuardWithRole(allowedRoles: UserRole[]): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const authService: AuthService = inject(AuthService);
    const router = inject(Router);
    const profile = authService.getProfile();

    //no profile means not logged in
    if (!profile) {
      router.navigate(['/auth/login']);
      return false;
    }

    //no role means no access
    if (!profile.role) {
      router.navigate(['/unauthorized']);
      return false;
    }

    const dbUserData = authService.dbUserData;

    //no user data means no access
    if (!dbUserData) {
      router.navigate(['/no-regions']);
      return false;
    }

    //if any role is allowed
    if (allowedRoles.includes(UserRole.ANY)) {
      return true;
    }

    //user does not have the required role
    if (!allowedRoles.includes(profile.role)) {
      router.navigate(['/unauthorized']);
      return false;
    }

    //for admin access, also check dbUserData
    if (allowedRoles.includes(UserRole.ADMIN)) {
      if (!dbUserData || dbUserData.role !== UserRole.ADMIN) {
        router.navigate(['/unauthorized']);
        return false;
      }
    }

    // default true means any group is valid
    return true;
  };
}
